import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";

/**
 * Machine handle reels and symbols for reels rotation.
 * Machine define behaviour for complete flow of reel rotation.
 * @class Machine
 * @extends BaseElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Machine extends BaseElement {
    // events for view when reel or machine stopped
    static MachineStopped: string = "machineStopped";

    constructor() {
        super();
    }

    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @return void
     */
    public create(node: Element): void {}

    /**
     * Get attributes from configuration and set up supported properties.
     * @method configurate
     * @param node is Element from xml
     * @return void
     */
    private configurate(node: Element): void {}

    /**
     * Start spinning reels.
     * @method spinStart
     * @param longRotation boolean
     * @return void
     */
    public spinStart(longRotation?: boolean): void {}

    /**
     * Stop reels rotation.
     * @method spinStop
     * @param event any - from timer
     * @param force boolean - default false used when spin_stop was dispatch
     * @param fromServer boolean - default false used when spin_stop was dispatch from server
     * @param legal
     * @return void
     */
    public spinStop(event: any, force: boolean = false, fromServer: boolean = false, legal: boolean = false): void {}
}

/**
 * Can inherit attributes from BaseElement
 */
export const MachineAttributes = {
    /*
     * Name of config for machine.
     * @property Configs
     * @type string
     * @default null
     */
    CONFIGS: "Configs",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Machine.ts
 **/